import { Component, ElementRef, HostBinding, input, OnInit, output } from '@angular/core';
import { ClickOutside } from '@shared/directives/click-outside';
import { FormsModule } from '@angular/forms';
import { E_CONTENT_TAG_TYPE, E_FR_LOC } from '@shared/constants/enums.const';
import { MatCheckbox } from '@angular/material/checkbox';
import { ButtonComponent } from '@shared/components/button/button.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HelperService } from '../../../../services/helper.service';
import { ITagCategoryItem } from '@shared/constants/models.const';


@Component({
  selector: 'app-select-category',
  imports: [
    ClickOutside,
    FormsModule,
    MatCheckbox,
    ButtonComponent,
    TranslateModule,
  ],
  templateUrl: './select-category.component.html',
  styleUrl: './select-category.component.scss',
})
export class SelectCategoryComponent implements OnInit {
  noPadding = input<boolean>(false);
  noLeftPadding = input<boolean>(false);
  changed = output<number[]>();
  ButtonTypes = BUTTON_TYPES;
  outputValue: number[] = [];
  isSelectionChanged = false;
  categoryList: ITagCategoryItem[] = [
    {
      DisplayName: 'All',
      value: E_CONTENT_TAG_TYPE.AllThree,
      checked: true,
    },
    {
      DisplayName: 'Financial',
      value: E_CONTENT_TAG_TYPE.Financial,
      checked: true,
    },
    {
      DisplayName: 'Sustainability',
      value: E_CONTENT_TAG_TYPE.Sustainability,
      checked: true,
    },
    {
      DisplayName: 'Other',
      value: E_CONTENT_TAG_TYPE.Other,
      checked: true,
    },

  ];

  allSelectedValue = 0;
  E_CONTENT_TAG_TYPE = E_CONTENT_TAG_TYPE;
  isDropdownOpen = false;
  latestSelection: ITagCategoryItem[] = [];

  selectedLabel = this.translate.instant('Viewing: all categories');
  protected readonly E_FR_LOC = E_FR_LOC;

  constructor(
    private elRef: ElementRef,
    private translate: TranslateService,
    public HELPER: HelperService,
  ) {}

  @HostBinding('class.no-padding')
  get isNoPadding() {
    return this.noPadding();
  }

  @HostBinding('class.no-left-padding')
  get isNoLeftPadding() {
    return this.noLeftPadding();
  }

  ngOnInit(): void {

    this.categoryList = this.HELPER.getTagCategoryList().categoryList;
    this.allSelectedValue = this.HELPER.getTagCategoryList().allSelectedValue;

    let tagTypes: number[] = this.HELPER.hasTags() || [];

    let isAllSelected = false;

    if (tagTypes) {
      if (Array.isArray(tagTypes)) {
        tagTypes = tagTypes.map(item => Number(item));
      } else {
        isAllSelected = Number(tagTypes) === this.allSelectedValue;
        tagTypes = [Number(tagTypes)];
      }

      this.outputValue = tagTypes;
      this.categoryList.forEach(item => {
        item.checked = isAllSelected || tagTypes.includes(item.value);
      });
      this.setSelectedLabel();
    }
    this.latestSelection = this.getLatestCategoryList();
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  clickOutside(): void {
    this.isDropdownOpen = false;
    this.categoryList = this.getLatestCategoryList(true);
    this.setSelectedLabel();
  }

  selectionChange(item: ITagCategoryItem) {

    let outputValue: number[] = [this.allSelectedValue];
    if (item.value === this.allSelectedValue) {
      this.categoryList.forEach(category => {category.checked = item.checked;});
    } else {
      const isAllSelected = this.checkIsAllSelected();
      this.categoryList.forEach(category => {
        if (category.value === this.allSelectedValue) {
          category.checked = isAllSelected;
        }
      });
      if (!isAllSelected) {
        const filteredArr = this.categoryList.filter(item => item.checked);
        outputValue = filteredArr.map(item => item.value);
      }

    }

    if (JSON.stringify(this.outputValue) !== JSON.stringify(outputValue)) {
      this.isSelectionChanged = true;
      this.outputValue = outputValue;
    }
    this.setSelectedLabel();
  }

  checkIsAllUnSelected(): boolean {
    return this.categoryList
      .filter(category => category.value !== this.allSelectedValue)
      .every(item => !item.checked);
  }

  checkIsAllSelected(): boolean {
    const filteredArr = this.categoryList.filter(category => category.value !== this.allSelectedValue);
    const isAllSelected = filteredArr.every(item => item.checked);
    const isAllUnselected = filteredArr.every(item => !item.checked);
    return isAllSelected || isAllUnselected;
  }

  setSelectedLabel(): void {
    this.selectedLabel = this.translate.instant('Viewing: all categories');
    const isAllSelected = this.checkIsAllSelected();

    if (!isAllSelected) {
      const filteredArr = this.categoryList.filter(item => item.checked);
      this.selectedLabel = filteredArr.map(item => this.translate.instant(item.DisplayName)).join(', ');
    }
  }

  getLatestCategoryList(getLatest = false): ITagCategoryItem[] {
    return JSON.parse(JSON.stringify(getLatest ? this.latestSelection : this.categoryList));
  }

  applySelection(): void {
    if (this.isSelectionChanged) {
      this.latestSelection = this.getLatestCategoryList();
      this.isSelectionChanged = false;
      this.HELPER.onCategoryChanged(this.outputValue);
    }
    this.isDropdownOpen = false;
  }

  cancelSelection(): void {
    this.categoryList = this.getLatestCategoryList(true);
    this.setSelectedLabel();
    this.isDropdownOpen = false;
  }

  getElement() {
    return this.elRef.nativeElement;
  }
}
